<div class="px-4 py-4">
  <h3 i18n="Left sidebar menu item title" class="overline text-gray">Pregled poslovanja</h3>
  <a [routerLink]="['/admin/business-overview/general-table-overview']" i18n-title title="Tabelaricni prikaz"
     [attr.data-test]="PermissionEnum.MENU_BUSINESS_OVERVIEW_TABLE_VIEW"
     routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"
     class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut">
        <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm"
              style="top: 2px">Tabelarični prikaz</span>
  </a>

  <a [routerLink]="['/admin/business-overview/general-graphical-overview']" i18n-title title="Graficni prikaz"
     [attr.data-test]="PermissionEnum.MENU_BUSINESS_OVERVIEW_GRAPHS_VIEW"
     routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"
     class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut">
    <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm" style="top: 2px">Grafični prikaz</span>
  </a>

  <a [routerLink]="['/admin/business-overview/plan-targets']" i18n-title title="Poslovni cilji"
     [attr.data-test]="PermissionEnum.MENU_BUSINESS_PLAN_TARGETS_MANAGE"
     routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"
     class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut">
    <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm" style="top: 2px">Poslovni cilji</span>
  </a>
</div>
